// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".align-middle[data-v-8b4fedc0] {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n.distribution-indicator img[data-v-8b4fedc0] {\n  width: 33px;\n}\n.distribution-indicator[data-v-8b4fedc0] {\n  height: 30px;\n  position: relative;\n}\n.distribution-indicator.distribution-secondary[data-v-8b4fedc0] {\n  top: -67px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
